import { render, staticRenderFns } from "./user-task-score-config.vue?vue&type=template&id=0cbdb0ea&scoped=true"
import script from "./user-task-score-config.vue?vue&type=script&lang=js"
export * from "./user-task-score-config.vue?vue&type=script&lang=js"
import style0 from "./user-task-score-config.vue?vue&type=style&index=0&id=0cbdb0ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdb0ea",
  null
  
)

export default component.exports